<template>
  <card>
    <loading-overlay :is-loading="loading.data"></loading-overlay>
    <h5 slot="header" class="title">Adauga Client</h5>
    <div class="row">
      <div class="col-md-9" v-bind:class="{'has-danger' : $v.customer.nume.$error, 'has-success' : !$v.customer.nume.$error && customer.nume}">
        <base-input :error="$v.customer.nume.$error"
                    @input="$v.customer.nume.$touch"
                    label="Nume*"
                    placeholder="Nume"
                    v-model="customer.nume">
        </base-input>
      </div>
      <div class="col-md-3" v-bind:class="{'has-danger' : $v.customer.cnp.$error, 'has-success' : !$v.customer.cnp.$error && customer.cnp}">
        <base-input :error="$v.customer.cnp.$error"
                    @input="$v.customer.cnp.$touch"
                    label="CNP/CUI*"
                    type="number"
                    placeholder="CNP"
                    aria-valuemax="13"
                    v-model="customer.cnp">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5" v-bind:class="{'has-danger ' : $v.customer.tel.$error, 'has-success' : !$v.customer.tel.$error && customer.tel}">
        <base-input label="Telefon*"
                    :error="$v.customer.tel.$error"
                    @input="$v.customer.tel.$touch"
                    type="number"
                    placeholder="Telefon"
                    v-model="customer.tel">
        </base-input>
      </div>
      <div class="col-md-7" v-bind:class="{'has-danger ' : $v.customer.email.$error, 'has-success' : !$v.customer.email.$error && customer.email}">
        <base-input label="Email"
                    :error="$v.customer.email.$error"
                    @input="$v.customer.email.$touch"
                    type="email"
                    v-model="customer.email"
                    placeholder="email@email.com">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9" v-bind:class="{'has-danger' : $v.customer.strada.$error, 'has-success' : !$v.customer.strada.$error && customer.strada}">
        <base-input label="Strada*"
                    :error="$v.customer.strada.$error"
                    @input="$v.customer.strada.$touch"
                    v-model="customer.strada"
                    placeholder="Strada">
        </base-input>
      </div>
      <div class="col-md-3" v-bind:class="{'has-danger' : $v.customer.nr_str.$error, 'has-success' : !$v.customer.nr_str.$error && customer.nr_str}">
        <base-input label="Nr.*"
                    :error="$v.customer.nr_str.$error"
                    @input="$v.customer.nr_str.$touch"
                    v-model="customer.nr_str"
                    placeholder="Nr.">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3" v-bind:class="{'has-danger' : $v.customer.judet.$error, 'has-success' : !$v.customer.judet.$error && customer.judet}">
        <base-input label="Judet*"
                    :error="$v.customer.judet.$error"
                    @input="$v.customer.judet.$touch"
                    v-model="customer.judet"
                    placeholder="Judet">
        </base-input>
      </div>
      <div class="col-md-3" v-bind:class="{'has-danger' : $v.customer.oras.$error, 'has-success' : !$v.customer.oras.$error && customer.oras}">
        <base-input label="Oras"
                    :error="$v.customer.oras.$error"
                    @input="$v.customer.oras.$touch"
                    v-model="customer.oras"
                    placeholder="Oras">
        </base-input>
      </div>
      <div class="col-md-3"  v-bind:class="{'has-danger' : $v.customer.sat.$error, 'has-success' : !$v.customer.sat.$error && customer.sat}">
        <base-input label="Sat"
                    :error="$v.customer.sat.$error"
                    @input="$v.customer.sat.$touch"
                    v-model="customer.sat"
                    placeholder="Sat">
        </base-input>
      </div>
      <div class="col-md-3">
        <base-input label="Cod postal"
                    type="number"
                    v-model="customer.cod_postal"
                    placeholder="Cod postal">
        </base-input>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <base-input label="Bloc"
                    v-model="customer.bloc"
                    placeholder="Bloc">
        </base-input>
      </div>
      <div class="col-md-3">
        <base-input label="Scara"
                    v-model="customer.scara"
                    placeholder="Scara">
        </base-input>
      </div>
      <div class="col-md-3">
        <base-input label="Etaj"
                    type="number"
                    v-model="customer.etaj"
                    placeholder="Etaj">
        </base-input>
      </div>
      <div class="col-md-3">
        <base-input label="Apartament"
                    type="number"
                    v-model="customer.apt"
                    placeholder="Apartament">
        </base-input>
      </div>
    </div>
    <br>
    <div>
      <h6>Nota:</h6>
      <label>Completeaza toate datele despre client pentru a avea formularele cat mai complete!</label>
    </div>
    <base-button slot="footer" type="primary" @click="save" :loading='loading.save'> Salveaza</base-button>
    <base-button slot="footer" type="default" style="margin-left: 10px" @click="$router.push('/customers-list')">Anuleaza</base-button>
  </card>
</template>
<script>
  const { required, minLength, between, maxLength, helpers, email } = require('vuelidate/lib/validators');
  import axios from "axios";
  import LoadingOverlay from "../../components/Loading/LoadingOverlay";
  const tel_validation = helpers.regex('numeric', /^(?:(?:(?:00\s?|\+)40\s?|0)(?:7\d{2}\s?\d{3}\s?\d{3}|(21|31)\d{1}\s?\d{3}\s?\d{3}|((2|3)[3-7]\d{1})\s?\d{3}\s?\d{3}|(8|9)0\d{1}\s?\d{3}\s?\d{3}))$/); //romania phone number
  const alpha = helpers.regex('alpha', /^[ A-Za-z_@.#&+-]*$/)

  export default {
    name: "CustomerForm",
    components: {LoadingOverlay},
    data() {
      return {
        customer: {},
        loading: {
          data: false,
          save: false,
        }
      }
    },
    validations: {
      customer: {
        nume: {required, minLength: minLength(2), alpha},
        cnp: {required},
        email: {email},
        tel: {required, tel_validation},
        strada: {required},
        nr_str: {required},
        judet: {required, minLength: minLength(2), alpha},
        oras: {minLength: minLength(2), alpha},
        sat: {minLength: minLength(2), alpha},
      }
    },
    mounted() {
      if (this.$route.params.customerId) {
        this.loading.data = true;
        axios.post("customer/details", {customerId: this.$route.params.customerId})
                .then((res) => {
                  this.loading.data = false;
                  this.customer = res.data;
                })
                .catch((err) => {
                  this.loading.data = false;
                  console.log(err);
                });
      }
    },
    methods: {
      save() {
        this.$v.customer.$touch();
        if (this.$v.customer.$error == true) {
          return false;
        }
        this.loading.save = true;
        axios.post('customer/save', this.customer)
                .then((res) => {
                  this.loading.save = false;
                  this.notifySuccess();
                  this.$router.push({name: 'customers'});
                })
                .catch((err) => {
                  this.loading.save = false;
                  console.log(err);
                });
      },
      notifySuccess() {
        this.$notify({
          type: 'success',
          message: 'Modificarile au fost salvate cu succes',
          icon: 'tim-icons icon-bell-55',
        })
      }
    },
  }
</script>
<style>
</style>
